import WithSidebar from 'Layout/WithSidebar';
import { productPageTitles } from 'components/ProductSideBar/mockData';
import './styles.scss';
import image from 'images/small-images-inside-text/wuxal.jpg';
import infoImage from 'images/info-image.jpg';
import aboutImage from 'images/about-product-image-text.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItemsBox from 'components/ProductItemsBox';
import { products, vegatables, vegatables2 } from 'components/ProductItemsBox/mockData';
import GeneralInfoBox from 'components/GeneralInfoBox';
import { Button } from 'components/buttons/Button/Button';
import BenefitsBox from 'components/BenefitsBox';
import ProductSideBar from 'components/ProductSideBar';
import PDFBox from 'components/PDFBox';
import { data } from 'components/BenefitsBox/mockData';
import { files } from 'components/PDFBox/mockData';

const AboutProducts = () => {
    return (
        <div className="container">
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>about product</LabelButton>
                    <GradientText>
                        New <img src={image} alt="decor" /> Wuxal’s are <em>products of a higher level,</em> more than
                        just a product of fertilizer
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="small">
                            Wuxal® — is an <em>effective suspension</em> for foliar treatment of plants and seed
                            treatment, as well as a set of innovative solutions that allow you to achieve high
                            efficiency.
                        </GradientText>
                    </div>
                </div>

                <WithSidebar Sidebar={<ProductSideBar items={productPageTitles} />}>
                    <div id={productPageTitles[0]}></div>
                    <GeneralInfoBox>
                        <h3>General information</h3>
                        <p>
                            These are multifunctional products for optimizing modern plant protection and nutrition
                            technologies. Unlike microfertilizers, they are recommended as a component of tank mixtures
                            in plant protection and nutrition systems. They have a high concentration of nutrients
                            specially selected for the physiological needs of plants.
                        </p>
                        <p>
                            The Wuxal offered in Ukraine is produced in Germany by order of UniferX International GmbH
                            at the Aglukon Spezialdünger GmbH & Co KG plant.
                        </p>
                        <p>
                            The plant, located in Düsseldorf, has been producing special fertilizers and biostimulants
                            for foliar feeding and seed treatment under the highest German quality standards since 1928.
                        </p>
                        <img src={infoImage} alt="" />
                        <p>
                            Wuxal has been known on the Ukrainian market since 2003 and has gained a reputation as a
                            high-quality, effective and reliable means of increasing crop productivity. The technologies
                            implemented in Wuxal are one step ahead of modern cultivation technologies.
                        </p>
                        <Button type="read-more">READ MORE</Button>
                    </GeneralInfoBox>
                    <img src={aboutImage} alt="info" />
                    <div id={productPageTitles[1]}></div>
                    <BenefitsBox title="Wuxal benefits" data={data} />
                    <div id={productPageTitles[2]}></div>
                    <ProductItemsBox title="Related products" data={products} />
                    <div id={productPageTitles[3]}></div>
                    <PDFBox title="Composition & compatibility" data={files} />
                    <div id={productPageTitles[4]}></div>
                    <ProductItemsBox title="Wuxal crop nutrition programs" data={vegatables} />
                    <div id={productPageTitles[5]}></div>
                    <ProductItemsBox title="Wuxal trial results" data={vegatables2} />
                </WithSidebar>
            </div>
        </div>
    );
};

export default AboutProducts;
